import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import login from "@/views/Login.vue";
import updatepwd from "@/views/setting/password/UpdateDefault.vue";
import main from "@/views/Main.vue";
import management from "@/router/management";
Vue.use(Router);
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/management"
    },
    {
      path: "/management",
      component: main,
      children: management
    },
    {
      path: "/login",
      component: login,
      meta: {
        ingoreAuth: true
      }
    },
    {
      path: "/updatepwd",
      component: updatepwd
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.ingoreAuth || store.getters.isLogin) {
    if (!store.state.calculateRole) {
      store.commit("calculateRole");
    }
    if (store.getters.getRedictRouter) {
      if (to.path === store.getters.getRedictRouter.path) {
        next();
      } else {
        next({ path: store.getters.getRedictRouter.path });
        store.commit("clearRedictRouter");
      }
    } else {
      next();
    }
  } else {
    next({ path: "login" });
  }
});
export default router;
